import { QueryClient } from '@tanstack/react-query';
import { AdminVideo } from '../model/dto/video/admin-video';
import { Paginated } from '../types';

export const ADMIN_VIDEOS_KEY = 'admin-videos';
export const ADMIN_VIDEO_KEY = 'admin-video';
export const ADMIN_VIDEO_PLACEMENTS_KEY = 'admin-video-placements';

export const applyVideoUpdate = (
  queryClient: QueryClient,
  video: AdminVideo
) => {
  queryClient.setQueryData([ADMIN_VIDEO_KEY, video.id], video);
  queryClient.setQueriesData<Paginated<AdminVideo>>(
    { queryKey: [ADMIN_VIDEOS_KEY] },
    (page) =>
      page && {
        ...page,
        docs: page.docs.map((doc) => (doc.id === video.id ? video : doc)),
      }
  );
};

export const invalidateVideoQueries = (queryClient: QueryClient) =>
  Promise.all([
    queryClient.invalidateQueries({ queryKey: [ADMIN_VIDEOS_KEY] }),
    queryClient.invalidateQueries({ queryKey: [ADMIN_VIDEO_KEY] }),
  ]);
